import {
  BrandPayload,
  BrandSubmitForm,
  Brands,
  UpdateBrandStatus,
} from "models/brand";
import axiosClient from "./axiosClient";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";

const brandApi = {
  getBrandsList(data: BrandPayload): Promise<Brands> {
    const sortBy = data.sortBy || data.sortField || data.sortName || "";
    const sortOrder = data.sortOrder || data.sortType || "";
    return axiosClient.get(`/brand/getBrandDetail`, {
      params: {
        limit: data.limit || "",
        page: data.page || "",
        search: data.search || "",
        sortField: data.sortField || data.sortName || "",
        sortType: data.sortType || "",
        sortBy,
        sortOrder,
        isActive: data.isActive !== undefined && data.isActive !== null ? data.isActive : "",
        isMultiBrand: data.isMultiBrand !== undefined && data.isMultiBrand !== null ? data.isMultiBrand : "",
        isProServer: data.isProServer !== undefined && data.isProServer !== null ? data.isProServer : "",
        isApproved: data.isApproved !== undefined && data.isApproved !== null ? data.isApproved : "",
        isDemoBrand: data.isDemoBrand !== undefined && data.isDemoBrand !== null ? data.isDemoBrand : "",
        name: data.name || "",
        region: data.region || "",
        email: data.email || "",
        startDate: data.startDate || "",
        endDate: data.endDate || "",
        integrationParty: data.integrationParty || "",
        invoiceStatus: data.invoiceStatus || "",
        billingCycle: data.billingCycle || "",
        subscriptionId: data.subscriptionId || "",
      },
      headers: {
        "Cache-Control": "no-cache",
      },
    });
  },
  getLocationsAndStoresByBrand(data: any): Promise<Brands> {
    return axiosClient.get(`/brand/getLocationsAndStoresByBrand`, {
      params: { brandId: data?.brandId }
    });
  },
  getBrandbyId(data: any): Promise<Brands> {
    return axiosClient.get(`/brand/getBrandById`, {
      params: {
        _id: data?.id || data?._id,
        locationPage: data?.locationPage || 1,
        locationLimit: data?.locationLimit || 5,
      },
      headers: {
        "Cache-Control": "no-cache",
      },
    });
  },
  getBrandDetail(id: string): Promise<any> {
    return axiosClient.get(`/brand/getBrandDetail?_id=${id || ""}`, {
      headers: {
        "Cache-Control": "no-cache",
      },
    });
  },
  getAllMainBrand(params?: { _id?: string } | string): Promise<ApiResponse> {
    const _id = typeof params === "string" ? params : params?._id;
    return axiosClient.get(`/brand/getAllMainBrand`, {
      params: _id ? { _id } : undefined,
    });
  },

  getCustomersList(data: BrandPayload): Promise<Brands> {
    return axiosClient.get(`/customer/getAllCustomer`, {
      params: {
        disablePagination: data.disablePagination !== undefined && data.disablePagination !== null ? data.disablePagination : undefined
      }
    });
  },

  addBrand(data: BrandSubmitForm): Promise<ApiResponse> {
    return axiosClient.post(`/brand/createBrandAndStore`, data);
  },

  addOrUpdateMultiStoreKotConfig(data: any): Promise<ApiResponse> {
    return axiosClient.post(`/kot/addOrUpdateMultiStoreKotConfig`, data);
  },

  updateBrand(data: BrandSubmitForm): Promise<ApiResponse> {
    return axiosClient.put(`/brand/updateBrandDetail`, data, {
      params: { id: data._id }
    });
  },

  deleteBrand(data: RemovePayload): Promise<ApiResponse> {
    return axiosClient.delete(`/brand/removeBrand`, {
      params: { id: data._id }
    });
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    return axiosClient.post(`/settings/uploadImage`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  changeBrandStatus(data: UpdateBrandStatus): Promise<ApiResponse> {
    return axiosClient.put(`/brand/approveBrand`, { isApproved: data.isApproved }, {
      params: { id: data.brandId }
    });
  },

  getBrandLocation(brandId: string): Promise<ApiResponse> {
    return axiosClient.get(`/location/getbrandLocation`, {
      params: { brandId }
    });
  },

  getKotConfigs(brandId: string): Promise<ApiResponse> {
    return axiosClient.get(`/kot/getKotConfigs`, {
      params: { brandId }
    });
  },
};

export default brandApi;
